export const ReviewSessionStatus = {
  DRAFT: 'DRAFT',
  DOING: 'DOING',
  FINISH: 'FINISH',
};

export const ReviewFormStatus = {
  DRAFT: 'DRAFT',
  DOING: 'DOING',
  FINISH: 'FINISH',
};

export function statusToVariant(status) {
  let v = 'light';
  switch (status) {
    case ReviewSessionStatus.DRAFT:
      v = 'secondary';
      break;
    case ReviewSessionStatus.DOING:
      v = 'success';
      break;
    case ReviewSessionStatus.FINISH:
      v = 'info';
      break;
  }

  return v;
}
